module.exports = __webpack_public_path__ + "static/media/19ESCAP14.28b3a15a.jpg";